import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  currentReturnTo,
  linkStateWithReturnTo,
  loginPathWithReturnTo,
  shouldIgnoreLoginReturnTo,
} from '../utils/navigationReturn';

const ProtectedRoute = ({
  children,
  requireAdmin = false,
  requireSuperAdmin = false,
  requirePmsSuppliersAccess = false,
  requireFtoEntitiesAccess = false,
  /** When set, SuperAdmin hide-overrides also block deep links (SuperAdmin bypasses). */
  sidebarMenuKey = null,
  permission,
  permissions,
}) => {
  const {
    isAuthenticated,
    isAdmin,
    isSuperAdmin,
    can,
    canAny,
    canBrowsePmsSuppliers,
    canBrowseFtoEntities,
    isSidebarMenuVisible,
    loading,
  } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    if (shouldIgnoreLoginReturnTo()) {
      return <Navigate to="/login" replace />;
    }
    const returnTo = currentReturnTo(location);
    return (
      <Navigate
        to={loginPathWithReturnTo(returnTo)}
        replace
        state={linkStateWithReturnTo(returnTo)}
      />
    );
  }

  if (requireSuperAdmin && !isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (sidebarMenuKey && !isSidebarMenuVisible(sidebarMenuKey)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (permission && !can(permission)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (permissions?.length && !canAny(...permissions)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requirePmsSuppliersAccess && !canBrowsePmsSuppliers) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireFtoEntitiesAccess && !canBrowseFtoEntities) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
